

























import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import SimpleAlert from "@/basics/alerts/SimpleAlert.vue";

import UploadCsvFile, {
  UploadEvent
} from "@/components/inputs/UploadCsvFile.vue";
import { createGroupsWithAdmin } from "@/graphql/mutation/createGroupsWithAdmin";
import { downloadAsFile } from "@/lib/download";

export interface InputError {
  row: number;
  name:
    | "グループ名"
    | "管理ユーザー名"
    | "メールアドレス"
    | "入居時リモート解施錠";
  message: string;
}

@Component({
  components: {
    CButton,
    UploadCsvFile,
    NoteBox,
    SimpleAlert
  }
})
export default class GroupsNew extends Vue {
  errors: InputError[] = [];
  checkToken = "グループ名,管理ユーザー名,メールアドレス,入居時リモート解施錠";

  get isIE(): boolean {
    const ua: string = window.navigator.userAgent.toLowerCase();
    if (ua.match(/trident\/7/)) {
      return true;
    }
    return false;
  }

  async upload({ text }: UploadEvent) {
    const result = await createGroupsWithAdmin(this.$apollo, text!);
    if (result.errors) {
      this.errors = result.errors || [];
      alert("登録できませんでした");
      return;
    }

    alert("登録しました");
    const csv = `${this.checkToken},ログインID,パスワード
${result
  .data!.map(d =>
    [
      d.groupName,
      d.adminName,
      d.email,
      d.allowRescue ? "許可" : "禁止",
      d.loginId,
      d.password
    ].join(",")
  )
  .join("\r\n")}
`;
    downloadAsFile("group-users-password.csv", "text/csv", csv);
    this.$router.push({ name: "groups-list" });
  }

  parseCheckError() {
    alert(
      `CSV読み込みに失敗しました。「${this.checkToken}」を確認できませんでした。`
    );
  }
}
